import useBodyScrollLock from '../../hooks/useBodyScrollLock'
import './Cart.css'

export default function Cart({
  isOpen      = false,
  items       = [],
  onClose     = () => {},
  onRemove    = () => {},
  onDetail    = () => {},
  isLoggedIn  = false,
  onAuthOpen  = () => {},
  onPay       = () => {}, // ouvre maintenant le CheckoutModal
}) {
  const fmt   = (n) => n.toLocaleString('fr-FR') + ' €'
  const total = items.reduce((s, i) => s + i.price, 0)

  useBodyScrollLock(isOpen)

  const handleCheckout = () => {
    if (!isLoggedIn) {
      onClose()
      onAuthOpen()
    } else {
      onClose()   // ferme le tiroir panier
      onPay()     // ouvre le CheckoutModal
    }
  }

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="cart-overlay" onClick={onClose} />}

      {/* Tiroir */}
      <div className={`cart-drawer${isOpen ? ' open' : ''}`}>
        <div className="cart-header">
          <div className="cart-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
            Mon Panier <span className="cart-count">{items.length}</span>
          </div>
          <button className="cart-close" onClick={onClose}>✕</button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <div className="cart-empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
            </div>
            <div className="cart-empty-title">Panier vide</div>
            <div className="cart-empty-sub">Ajoutez des annonces à votre panier pour les retrouver ici.</div>
            <button className="cart-empty-btn" onClick={onClose}>Parcourir les annonces</button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div key={item.id} className="cart-item">
                  <img className="cart-item-img" src={item.img} alt={item.title} loading="lazy" onClick={() => onDetail(item.id)} />
                  <div className="cart-item-info">
                    <div className="cart-item-breed">{item.breed}</div>
                    <div className="cart-item-title" onClick={() => onDetail(item.id)}>{item.title}</div>
                    <div className="cart-item-city">📍 {item.city}</div>
                    <div className="cart-item-price">{fmt(item.price)}</div>
                  </div>
                  <button className="cart-item-del" onClick={() => onRemove(item.id)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-total-row">
                <span>Total</span>
                <span className="cart-total">{fmt(total)}</span>
              </div>
              <div className="cart-total-note">Livraison internationale incluse</div>
              <button className="cart-checkout" onClick={handleCheckout}>
                {isLoggedIn ? '💳 Procéder au paiement' : '🔒 Se connecter pour payer'}
              </button>
              <button className="cart-continue" onClick={onClose}>← Continuer mes achats</button>
            </div>
          </>
        )}
      </div>
    </>
  )
}